$(function () {
    $('li.menu-item-has-children').on('click', function (event) {

        let parentLi = $(event.target).closest('li');
        let hasSubmenu = parentLi.hasClass('menu-item-has-children');

        if (!hasSubmenu) {
            return true;
        }

        event.preventDefault();
        return false;
    });
});
